module.exports = "data:image/svg+xml,%3Csvg width='13' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 11.44L.005.19h12.99L6.5 11.44z' fill='%23FF4C48'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg-icons/polygon-orange.svg
// module id = 626
// module chunks = 1